module.exports = __webpack_public_path__ + "static/media/facebook.78a28133.svg";